/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    templateCollectionData: [
        {
            header: '<h1>Advice From a Sunflower</h1><p>Hold your head high. Look on the sunny day. And always shine.</p>',
            key: '/sunflowers',
            class: 'sunflowersContainer',
        },
    ],
};
export default data;
